<div class="file-list">
  <div class="file-list-area">
    <rappider-spin [spinning]="fileListItem.loading">
      <rappider-list-grid [config]="FILE_LIST_CONFIG"
                          [data]="fileList"
                          (columnActionClick)="onAddFile($event)"></rappider-list-grid>
    </rappider-spin>
  </div>
</div>
